export default __webpack_public_path__ + "images/WT.ec03157.png";